import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFind = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.1271 21.0928C19.67 21.6356 20.55 21.6357 21.0929 21.0928C21.6358 20.5499 21.6357 19.6699 21.0929 19.127L16.3829 14.418C17.2259 13.193 17.7208 11.7098 17.7208 10.1104C17.7208 5.90733 14.3135 2.50001 10.1105 2.5C5.90746 2.50002 2.50014 5.90734 2.50012 10.1104C2.50027 14.3133 5.90754 17.7207 10.1105 17.7207C11.7094 17.7207 13.1923 17.2262 14.4171 16.3838L19.1271 21.0928ZM10.1105 15.8662C6.9313 15.8662 4.35379 13.2895 4.35364 10.1104C4.35366 6.9311 6.93122 4.35354 10.1105 4.35352C13.2897 4.35352 15.8673 6.93109 15.8673 10.1104C15.8672 13.2895 13.2897 15.8662 10.1105 15.8662Z",
		fill: "white"
	})
});
const ForwardRef = forwardRef(SvgFind);
export default ForwardRef;
